export const readLS = <T>(key: string, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
};

export const writeLS = (key: string, value: unknown): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (_error) {
    // Storage may be unavailable in private mode or when the quota is full.
  }
};

export const removeLS = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (_error) {
    // Storage cleanup is best effort.
  }
};
